import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FaRegLightbulb } from 'react-icons/fa';
import Text from '../Text';
import CarouselInformation from '../Carousel';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 'min(98vw, 1800px)',
  height: '96vh',
  bgcolor: 'background.paper',
  border: '1px solid #d9dde4',
  borderRadius: '8px',
  boxShadow: 24,
  p: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

export default function TravelInformationCarousel({ textStyle }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const defaultTextStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: 0,
    margin: 0,
    color: '#fff',
    lineHeight: 1.2,
    cursor: 'pointer',
  };

  return (
    <div>
      <Text color="white" style={{ ...defaultTextStyle, ...textStyle }} onClick={handleOpen}>
        <FaRegLightbulb
          style={{
            width: 'auto',
            height: 'auto',
            fontSize: '1rem',
            color: '#fff',
            flexShrink: 0,
          }}
        />
        Informações Acompanhamento de viagens
      </Text>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ zIndex: 10002 }}
        slotProps={{
          backdrop: {
            sx: { zIndex: 10001 },
          },
        }}
      >
        <Box sx={{ ...style, zIndex: 10002 }}>
          <CarouselInformation />
        </Box>
      </Modal>
    </div>
  );
}
